import { render } from "./ListOfWorks.vue?vue&type=template&id=f2a047c4"
import script from "./ListOfWorks.vue?vue&type=script&lang=js"
export * from "./ListOfWorks.vue?vue&type=script&lang=js"

import "./ListOfWorks.vue?vue&type=style&index=0&id=f2a047c4&lang=scss"

import exportComponent from "/home/wf13/Develop/web/vue-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__